/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Heading, VFlow } from 'bold-ui'

import { ListaRegulacaoTableItem } from '../../model-regulacao'

export interface RegulacaoModalItemProps {
  item: ListaRegulacaoTableItem
}

interface RegulacaoItemProps {
  title: string
  subtitle: React.ReactNode | string
}

export const RegulacaoItem = (props: Readonly<RegulacaoItemProps>) => {
  const { title, subtitle } = props
  return (
    <VFlow vSpacing={0}>
      <Heading level={5} fontWeight='bold'>
        {title}
      </Heading>
      <Heading level={5} fontWeight='normal' style={styles.subtitle}>
        {subtitle}
      </Heading>
    </VFlow>
  )
}

const styles = {
  subtitle: css`
    word-break: break-word;
  `,
}
